import { Button } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';

type ButtonProps = ComponentProps<typeof Button>;

export const LoadMoreButton = ({ onClick }: Pick<ButtonProps, 'onClick'>) => {
  return (
    <Button
      variant="outline"
      w="full"
      h={12}
      border="1px solid #3D1690"
      bg="generic.0"
      color="primary.500"
      textStyle="label.medium"
      fontWeight="normal"
      borderRadius="8px"
      onClick={onClick}
    >
      Load More Reviews
    </Button>
  );
};

export default LoadMoreButton;
